import { Locales } from '@griply/types';
import { Locale, setDefaultOptions } from 'date-fns';
import { de } from 'date-fns/locale/de';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { nl } from 'date-fns/locale/nl';
import { useEffect } from 'react';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';

const localeMap: Record<string, Locale> = {
  'en-US': enUS,
  'nl-NL': nl,
  'de-DE': de,
  'es-ES': es,
};

export const useLocale = () => {
  const locale = useI18nLocale();

  useEffect(() => {
    setDefaultOptions({
      locale: localeMap[locale] ?? localeMap[Locales.EnUS],
    });
  }, [locale]);
};
